<template>
    <transition name="height">
        <slot></slot>
    </transition>
</template>

<script>
export default {};
</script>

<style>
.height-enter-from,
.height-leave-to {
    height: 0px !important;
    max-height: 0px !important;
}
.height-enter-active,
.height-leave-active {
    overflow: hidden !important;
}
</style>
